import axios from 'axios';
import { apiMainUrl } from '../apiConfig';

const API_BASE_URL = apiMainUrl + 'Article'; // Adjust the URL based on your actual API's URL

// Create a new article
const createArticle = async (article, token) => {
    try {
        const response = await axios.post(`${API_BASE_URL}`, article, {
            headers: {
                'Authorization': `Bearer ${token}`,
                //'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to create article:', error);
        throw error;
    }
};

// Fetch all articles (with optional active filter)
const getAllArticles = async (token, onlyActive = false) => {
    try {
        const response = await axios.get(`${API_BASE_URL}?onlyActive=${onlyActive}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch articles:', error);
        throw error;
    }
};

// Get details of a specific article by ID
const getArticleById = async (id, token) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch article with ID ${id}:`, error);
        throw error;
    }
};

// Update an existing article
const updateArticle = async (id, article, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${id}`, article, {
            headers: {
                'Authorization': `Bearer ${token}`,
                // 'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error(`Failed to update article with ID ${id}:`, error);
        throw error;
    }
};

// Delete an article
const deleteArticle = async (id, token) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;
    } catch (error) {
        console.error(`Failed to delete article with ID ${id}:`, error);
        return error.response;
    }
};

// Activate or deactivate an article
const toggleArticleActivation = async (id, isActive, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${id}/activate?isActive=${isActive}`, null, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error(`Failed to change activation status of article with ID ${id}:`, error);
        throw error;
    }
};

const incrementReadCount = async (id, token) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/${id}/increment-read-count`, null, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error(`Failed to update article with ID ${id}:`, error);
        throw error;
    }
};

export const ArticlesDataService = {
    createArticle,
    getAllArticles,
    getArticleById,
    updateArticle,
    deleteArticle,
    toggleArticleActivation,
    incrementReadCount
};
